// src/pages/talleres/editar/constants.js

export const TIPOS_ACTIVIDAD = [
  { label: 'Actividad Física y Salud (AFS)', value: 'Actividad Física y Salud (AFS)' },
  { label: 'Academias Deportivas (AD)', value: 'Academias Deportivas (AD)' },
  { label: 'Escuelas Deportivas (ED)', value: 'Escuelas Deportivas (ED)' },
  { label: 'Escuelas Abiertas (EA)', value: 'Escuelas Abiertas (EA)' },
  { label: 'Deporte Vecinal (DVEC)', value: 'Deporte Vecinal (DVEC)' },
  { label: 'Personas Mayores (PM)', value: 'Personas Mayores (PM)' },
  { label: 'Fútbol (FUT)', value: 'Fútbol (FUT)' },
  { label: 'Juegos Deportivos Escolares (JDE)', value: 'Juegos Deportivos Escolares (JDE)' },
  { label: 'Kinesiología (KINE)', value: 'Kinesiología (KINE)' },
  { label: 'Bienestar (BIE)', value: 'Bienestar (BIE)' },
  { label: 'Asistencia a las OODD (OODD)', value: 'Asistencia a las OODD (OODD)' },
  { label: 'Intersectorialidad (INT)', value: 'Intersectorialidad (INT)' },
  { label: 'Proyectos (PRO)', value: 'Proyectos (PRO)' },
  { label: 'Sistema de Apoyo a Deportistas (SAD)', value: 'Sistema de Apoyo a Deportistas (SAD)' },
  { label: 'Eventos (EV)', value: 'Eventos (EV)' },
];

export const DIAS_OPTIONS = [
  { label: 'Lunes', value: 'lunes' },
  { label: 'Martes', value: 'martes' },
  { label: 'Miércoles', value: 'miércoles' },
  { label: 'Jueves', value: 'jueves' },
  { label: 'Viernes', value: 'viernes' },
  { label: 'Sábado', value: 'sábado' },
  { label: 'Domingo', value: 'domingo' },
];

// 🔥 AGREGAR ESTAS CONSTANTES
export const PLANES = [
  { label: "Mensual", value: "mensual" },
  { label: "Trimestral", value: "trimestral" },
  { label: "Semestral", value: "semestral" },
  { label: "Anual", value: "anual" },
];

// 🔥 AGREGAR ESTAS CONSTANTES
export const CAMPOS_VALORES_EXT = [
  { key: "valorParticular", label: "Valor particular", required: true },
  { key: "valorVecino", label: "Valor vecino", required: false },
  { key: "valorAdultoMayor", label: "Valor adulto mayor", required: false },
  { key: "valorFuncionarios", label: "Valor funcionarios", required: false },
  { key: "matricula", label: "Matrícula", required: false },
];

export const TIPO_DURACION_OPTIONS = [
  {
    label: '📅 Mes calendario (día a día)',
    value: 'mes_calendario',
  },
  {
    label: '📆 Fin de mes',
    value: 'fin_de_mes',
  },
  {
    label: '📆 Mes corrido (30 días)',
    value: 'mes_corrido',
  },
];

export const diasOrder = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];

export const STEPS = [
  { title: "Info básica", key: "info" },
  { title: "Fechas", key: "fechas" },
  { title: "Pagos", key: "pagos" },
  { title: "Resumen", key: "resumen" },
];

export const INITIAL_VALUES = {
  esGratuito: false,
  liberarCuposPorBaja: true,
  tipoDuracionSuscripcion: 'mes_corrido'
};
